var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { staticClass: "note", class: _vm.isMyNote ? "my-note" : "other-note" },
    [
      _c(
        "div",
        { staticClass: "note__header", class: { "flex-end": _vm.isMyNote } },
        [
          !_vm.isMyNote
            ? _c("span", [_vm._v(_vm._s(_vm.note.user_name))])
            : _vm._e(),
          _vm._v(" "),
          _c("span", [
            _vm._v(_vm._s(_vm.dateParser(_vm.note.date.split(" ")[0]))),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "note__comment",
        domProps: { innerHTML: _vm._s(_vm.note.text) },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }